import { Component, createPlatform, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SelectItem } from 'primeng/api';
import { IssoUtilService } from 'src/app/services/isso-util.service';
import { ReportMeritService } from '../service/report-merit.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-student-attendance',
  templateUrl: './student-attendance.component.html',
  styleUrls: ['./student-attendance.component.css']
})
export class StudentAttendanceComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  yearOptions: SelectItem[];
  eventOptions: SelectItem[];
  gameOptions: SelectItem[];
  schoolOptions: SelectItem[];
  ageOptions: SelectItem[];
  genderOptions: SelectItem[];
  studentAttendanceArray=[];
  studentAbsentArray=[];
  attendanceArray=[];
  // Checkbox selection. The same selection is submitted as either present or
  // absent depending on which button is pressed, so a student is never sent in
  // both lists.
  selectedIds: number[] = [];
  isSaving: boolean = false;

  gameIdList:any;
  gameNameList:any;
  myObjArray: any;

  eventValue:number;
  yearvalue:number;
  schoolvalue:number;
  eventData: any;
  schoolDataArray =[];
  eventReadable: boolean = false;
  gameReadble: boolean = false;
  schoolReadble: boolean = false;
  selectedEvent:string;
  schoolList: any;
  gameList: any;
  public gameID: number;
  public schoolID: any;
  certificateData: any;
  reportData: any;
  coachData: any;
  isCertificate: boolean = false;
  isDataAvailble: boolean = false;
  schooName:string;
 
  showspinner: boolean = false;
  reportDataLength: number;
  selectedGame: string;
  selectedSchool: string;
  selectedYear: string;
  imageData: any;
  isConsolited: boolean;
  genderReadble: boolean;
  ageValue: any;
  genderVal: any;
  consolidatedData: any;
  consoliDatedLength: any;
  checked1: boolean = true;
  consolateFileName: any;
  gameType: any;
  selectedYearVal: string;
  studentAttendance: boolean;

  selectedCities: string[] = [];

  selectedCategories: any[] = ['Technology', 'Sports'];

  categories: any[] = [{name: 'Accounting', key: 'A'}, {name: 'Marketing', key: 'M'}, {name: 'Production', key: 'P'}, {name: 'Research', key: 'R'}];

  checked: boolean = false;
  gameArray= [];
  reportValue: any;
  reportLabel: string;

   constructor( private issoUtilService: IssoUtilService, private messageService: MessageService, private meritService: ReportMeritService) { }

    ngOnInit() {
       this.isDataAvailble = false;
      this.yearOptions = this.issoUtilService.setYear();
     // this.selectedCategories = this.categories.slice(1,3);
     this.reportLabel = 'attendance';
    }
    onyeareChange(event) {
      this.studentAttendanceArray = [];
      this.studentAbsentArray = [];
      this.selectedIds = [];
      this.yearvalue = event.value;
      this.meritService.loadEventByYearForReport(this.yearvalue,0).pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if(response!=="") {
            this.eventData =response;
            this.gameReadble =false;
            this.schoolReadble  = false;
            if(this.eventData.length > 0 ){
              this.eventOptions = [];
              this.eventReadable = true;
              this.isDataAvailble = false;
              this.eventOptions.push({
                label: "Please Select",
                value: ''
              });
              this.eventData.forEach(element => {
                this.eventOptions.push({
                  label: element.eventName,
                  value: element.eventId
                });
              })
            } else {
              this.isDataAvailble = false;
              this.eventReadable = false;
              this.gameReadble =false;
              this.schoolReadble = false;
              this.messageService.add({key: 'custom', severity:'error', summary: 'Event not found for this year'});
            }
          } else {
          }
    
      } ,
      error => {
        //this.errorAlert =true;
        });
    }
    onEventChange(event) {
      this.studentAttendanceArray = [];
      this.studentAbsentArray = [];
      this.selectedIds = [];
      let yearVal = this.yearvalue.toString();
      let eventYear = yearVal.split("-");
      this.selectedYearVal = eventYear[1];

      if (eventYear[1] > '2020')   {
        this.reportGreaterForNewYear(event)
      } else {
      
      this.eventValue = event.value;
      this.gameOptions =[];
      this.selectedGame =''; 
      this.meritService.loadGameByEvent(this.eventValue, false).pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if(response!=="") {
            this.gameList =response;
            this.schoolReadble = false;
            if(this.gameList.length > 0 ) {
              this.gameOptions = [];
              this.gameReadble = true;
              this.isDataAvailble = false;
              this.gameList.forEach(element => {
                this.gameOptions.push({
                  label: element.gameName,
                  value: element.gameId
                });
            })
          } else {
            this.isDataAvailble = false;
            this.gameReadble = false;
            this.schoolReadble = false;
          }
          } else {
          }
    
      } ,
      error => {
        //this.errorAlert =true;
      });
    }
    }
    reportGreaterForNewYear(event) {
      this.eventValue = event.value;
      this.studentAttendanceArray = [];
      this.studentAbsentArray = [];
      this.selectedIds = [];
      this.consolateFileName =event.originalEvent.currentTarget.ariaLabel

      this.gameOptions =[];
      this.selectedGame =''; 
      this.meritService.loadGameForStaff(this.eventValue).pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if(response!=="") {
            this.gameList =response;
            this.schoolReadble = false;
            if(this.gameList.length > 0 ) {
              this.gameIdList = this.gameList[0].gameId.split(',')
              this.gameNameList =  this.gameList[0].game_name.split(',')
              this.myObjArray = [];
              
              for(let i=0;i<this.gameIdList.length;i++) {
                this.myObjArray.push({gameId: Number(this.gameIdList[i]), game_name: this.gameNameList[i] });
              } 
    
              this.gameOptions = [];
              this.gameReadble = true;
              this.isDataAvailble = false;
              this.gameOptions.push({
                label: "Please Select",
                value: '',
              });
             
              this.gameList.forEach(element => {
                const gameIdAndName = element.gameId +','+ element.game_name +','+ element.gameType;
                this.gameOptions.push({
                  label: element.game_name,
                  value: gameIdAndName
                });
              })
          } else {
            this.isDataAvailble = false;
            this.gameReadble = false;
            this.schoolReadble = false;
          }
          } else {
          }
    
      } ,
      error => {
        //this.errorAlert =true;
      });
    }
    loadGameChange(gameData) {
      this.studentAttendanceArray = [];
      this.studentAbsentArray = [];
      this.selectedIds = [];
      this.gameID = gameData.value;
      this.selectedSchool =''; 


      const gameDataValues = gameData.value
      this.gameArray =  gameDataValues.split(","); 
      const gameId = this.gameArray[0];
     // this.eventName =  this.eventArray[1];

      this.meritService.checkGameType(this.gameID).pipe(takeUntil(this.destroy$)).subscribe( 
        response => {
          this.gameType = response;
        },

        error => {
        //this.errorAlert =true;
      });

      this.meritService.loadSchoolByGameReport(this.eventValue, gameId).pipe(takeUntil(this.destroy$)).subscribe(
        response => {
          if(response!=="") {
            this.schoolList =response;
            if(this.schoolList.length > 0 ) {
              this.schoolOptions = [];
              this.schoolReadble = true;
              this.isDataAvailble = false;
              this.schoolOptions.push({
                label: "Please Select",
                value: ''
              });
              this.schoolList.forEach(element => {
                const  SchoolIdAndName = element.schoolId +','+ element.schoolName;
                this.schoolOptions.push({
                  label: element.schoolName,
                  value: SchoolIdAndName
                });
              })
          } else {
            this.messageService.add({key: 'custom', severity:'error', summary: 'School not found for this game'});
            this.isDataAvailble = false;
            this.schoolReadble = false;
          }
          } else {
          }
    
      } ,
      error => {
        //this.errorAlert =true;
    });
    }
    
    loadschoolChange(schoolData) {
      this.studentAttendance = false;
      this.studentAttendanceArray = [];
      this.studentAbsentArray = [];
      this.selectedIds = [];
      this.attendanceArray  =[];
      this.schoolID = schoolData.value;
      this.schoolDataArray =  this.schoolID.split(","); 
      this.schooName =this.schoolDataArray[1];
      if(this.schoolID !=='') {
      this.meritService.getStudentData(this.eventValue,this.gameID,this.schoolDataArray[0]).pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        if(response!=="") {
            this.reportData = response;
            this.reportDataLength = this.reportData.length;
         //   this.selectedCategories = this.reportData.filter(item => item !== this.reportData.isPresent);

            for (let i=0;i < this.reportData.length;i++) {
               if (this.reportData[i].isPresent === '1') {
               //  this.studentAbsentArray.push(this.reportData[i].sId);
               //  console.log('Im array==>'+this.studentAbsentArray);
              //  this.selectedCategories = this.reportData.splice(i, 1); 

                //  console.log('Hello==>'+i)
                //  this.attendanceArray.push(i);
                //  let x= i+1;
                //  this.selectedCategories = this.reportData.slice(1,x);
                // this.studentAttendanceArray.push(this.reportData[i].sId);
                //  if(this.studentAttendanceArray.length > 0) {
                //   this.studentAttendance = true;
                // }
               }  else {
               }
            }
                  //this.selectedCategories = this.categories.slice(1,3);

            // console.log('new===>'+this.attendanceArray);
            // this.selectedCategories = this.reportData.slice(1,3);
            // console.log('nasdasdasdew===>'+ this.selectedCategories);

          if(this.reportDataLength > 0) {
            this.isDataAvailble = true;
          //  this.showspinner = false;
          } 
        } else {
        }

    } ,
    error => {
      //this.errorAlert =true;
      });
    } else {
      this.isDataAvailble = false;
    }
  }
  onloadMenu(index) {
    this.reportValue = index;
    if(index == '0') {
      this.isConsolited = false;
      this.reportLabel = "attendance"
    }
  }
  /** Row checkbox. Selection is status-agnostic - the button decides present vs absent. */
  toggleStudent(event: any, studentId: number) {
    const checked = event && event.target ? event.target.checked : !!event;
    const at = this.selectedIds.indexOf(studentId);
    if (checked) {
      if (at === -1) { this.selectedIds.push(studentId); }
    } else if (at > -1) {
      this.selectedIds.splice(at, 1);
    }
    this.studentAttendance = this.selectedIds.length > 0;
  }

  isSelected(studentId: number): boolean {
    return this.selectedIds.indexOf(studentId) > -1;
  }

  get allSelected(): boolean {
    return !!this.reportData && this.reportData.length > 0
      && this.selectedIds.length === this.reportData.length;
  }

  toggleAll(event: any) {
    const checked = event && event.target ? event.target.checked : !!event;
    this.selectedIds = checked && this.reportData
      ? this.reportData.map((s: any) => s.sId)
      : [];
    this.studentAttendance = this.selectedIds.length > 0;
  }

  markPresent() { this.submitAttendance(true); }

  markAbsent() { this.submitAttendance(false); }

  /**
   * Marking present is what releases the student's participation certificate,
   * so the two lists are kept mutually exclusive: whichever button was pressed
   * gets the whole selection and the other list is sent empty.
   */
  private submitAttendance(present: boolean) {
    if (this.selectedIds.length === 0 || this.isSaving) { return; }
    this.isSaving = true;

    this.studentAttendanceArray = present ? this.selectedIds.slice() : [];
    this.studentAbsentArray = present ? [] : this.selectedIds.slice();

    const formData = new FormData();
    formData.append('studentData', JSON.stringify(this.studentAttendanceArray));
    formData.append('studentAbsentData', JSON.stringify(this.studentAbsentArray));

    this.meritService.saveStudentAttendance(formData).pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        this.isSaving = false;
        if (response && response.status === 'error') {
          this.messageService.add({severity:'error', summary: 'Error Message', detail:'Validation failed'});
          return;
        }
        const count = this.selectedIds.length;
        this.messageService.add({
          key: 'custom',
          severity: 'success',
          summary: count + (count === 1 ? ' student marked ' : ' students marked ') + (present ? 'Present' : 'Absent'),
        });
        this.selectedIds = [];
        this.studentAttendanceArray = [];
        this.studentAbsentArray = [];
        this.studentAttendance = false;
        this.showUpdatedPaymeData();
      },
      error => {
        this.isSaving = false;
        this.messageService.add({severity:'error', summary: 'Error Message', detail:'Could not save attendance'});
      });
  }

  showUpdatedPaymeData() {
    this.meritService.getStudentData(this.eventValue,this.gameID,this.schoolDataArray[0]).pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        if(response!=="") {
            this.reportData = response;
            this.reportDataLength = this.reportData.length;
            for (let i=0;i < this.reportData.length;i++) {
               if (this.reportData[i].isPresent === '1') {
              
               }  else {
               }
            }
     

          if(this.reportDataLength > 0) {
            this.isDataAvailble = true;
          //  this.showspinner = false;
          } 
        } else {
        }

    } ,
    error => {
      //this.errorAlert =true;
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}